<script lang="ts">
    import { i18n } from "../../store"

    export let item
</script>

<div class="slide">
    <div class="image">
        <picture>
            <source media="(min-width: 768px)" srcset="" />
            <source srcset="" />
            <img src="{item.image}" alt="{item.title || ''}" />
        </picture>
    </div>
    <div class="text">
        <div class="text_inner animated">
            {#if item.author}
                <div class="author">{item.author}</div>
            {/if}
            {#if item.title}
                <div class="headline">{item.title}</div>
            {/if}
            <div class="content">
                {@html item.teasertext}
            </div>
            <a href="{item.link}" class="btn">{$i18n("mehr")}</a>
        </div>
    </div>
</div>

<style lang="less">
    @import "../../css/base.less";
    .slide {
        height: auto;
        position: relative;
        background: #fff;
        -webkit-box-shadow: 0px 0px 20px 3px rgba(0, 0, 0, 0.1);
        .flex();
        @media (max-width: 1250px) {
            flex-flow: column;
        }
        .image {
            line-height: 0;
            width: 40%;
            height: auto;
            @media (max-width: 1250px) {
                width: 100%;
            }
            img {
                width: 100%;
                height: auto;
            }
        }
        .text {
            width: 60%;
            @media (max-width: 1250px) {
                width: 100%;
            }
            .flex();
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            .text_inner {
                width: 100%;
                position: relative;
                background: #ffffff;
                padding: 20px;
                .btn {
                    margin-top: 20px;
                }
            }
            .text_inner:after {
                right: 100%;
                top: 40px;
                border: solid transparent;
                content: "";
                height: 0;
                width: 0;
                position: absolute;
                pointer-events: none;
                border-color: rgba(255, 255, 255, 0);
                border-right-color: #ffffff;
                border-width: 20px;
                margin-top: -20px;
                @media (max-width: 1250px) {
                    transform: rotate(90deg);
                    top: -20px;
                    left: 40px;
                }
            }
            .author {
                font-size: 1.2rem;
                font-weight: 700;
            }
            .headline {
                font-size: 1.8rem;
                margin-bottom: 15px;
            }
        }
    }
</style>
